export const colors = {
  inputText: '#2c2e2f',
  inputBorder: '#cccccc',
  vxGreen: '#299976',
  vxGray: '#9DA3A6',
  vxDarkGray: '#2c2e2f',
  vxLegalText: '#6c7378',
}
